import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { VoucherCodeService } from '../../services/voucher-code.service';
import { VoucherInformationService } from '../../services/voucher-information.service';
import { BundlePackageInformationService } from '../../services/bundle-package-information.service';
import { CampaignService } from '../../services/campaign.service';
import { TransactionsService } from '../../services/transactions.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { VoucherSearchUpdateService } from '../../services/voucher-search-update.service';
import { MerchantService } from '../../services/merchant.service';
import { CreateVoucherService } from '../../services/create-voucher.service';
import { parseISO } from 'date-fns';
@Component({
    selector: 'app-common-modal',
    templateUrl: './common-modal.component.html',
    styleUrls: ['./common-modal.component.css'],
    standalone: false
})
export class CommonModalComponent implements OnInit {
  @Input() validationVal: any;
  @Input() public responseStructure: any;
  @Input() locationValidModal: any;
  @Input() successModal: any;
  @Input() successModalVariant: any;
  @Input() successUpdateModal: any;
  @Input() createVoucherModal: any;
  @Input() statusModal: any;
  @Input() campaignStatusModal: any;
  @Input() tipTotal: any;
  @Input() tipPartial: any;
  @Input() tipActive: any;
  @Input() apiResponseModal: any;
  @Input() eventStatus: any;
  @Input() eventActive: any;
  @Input() salesBundleModal: any;
  @Input() campaignSuccessModal: any;
  variantOn: any;
  formGroupSubject = new BehaviorSubject<String>('');
  @Input() errorModal: any;
  @Input() error: any;
  deleteVoucherModal: any = false;
  deleteResponse: any;
  deleteError: any;
  @Input() voucherId: any;
  @Input() variantId: any;
  @Input() deleteVoucherConfirmationModal: any;
  @Input() tierModal: any;
  @Input() tierVariantModal: any;
  @Input() dataUpdateModal: any;
  @Input() expiryDateExtendModal: any;
  @Input() transactionDetail: any;
  @Input() changeOwnerModal: any;
  @Input() cancelTransactionModal: any;
  @Input() changeStatus: any;
  @Input() id: any;
  @Input() deleteModal: any;
  @Input() expiryDateModal: any;
  @Input() index: any;
  @Input() newVariantIdList: any;
  @Input() childStatusArr: any;
  @Input() campaignId: any;
  @Input() voucherStatusCheckModal: any;
  @Input() selectCampaign: any;
  @Input() campaignVoucherData: any;
  @Input() statusConfirmationModal: any;
  @Input() statusConfirmationModalObj: any;
  @Input() deleteCampaignConfirmationModal: any;
  @Input() transactionId: any;
  @Input() updateCatalogueFlag: any;
  @Input() voucherIDList: Number[] = [];
  @Input() campaignVoucherTitle: string = '';
  @Input() campaignVoucherIdLists: Number[] = [];
  @Input() campaignVoucherBulkUpdate: boolean = false;
  @Input() activityLogModal: boolean = false;
  @Input() activityLogDescription: string = '';
  @Input() countryMarketModal: boolean = false;
  @Input() countryMarketImageModal: boolean = false;
  @Input() isMarketUpdate: boolean = false;
  formatDate: any;
  newEnrichId: any;
  remarks: any;
  campaignList: any;
  campaignForm!: UntypedFormGroup;
  campaignFormSubmitted = false;
  cancelTransactionForm!: UntypedFormGroup;
  transactionSuccessModal: boolean = false;
  transactionSuccessMsg: string = '';
  transactionConfirmationModal: boolean = false;
  transactionConfirmationMsg: string = '';
  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
  };
  catalogueOverride: boolean = false;
  catalogueOverrideObj: any = {};
  campaignVoucherBulkValidErr: boolean = false;
  campaignVoucherBulkStatusFail: boolean = false;
  BaseVoucherListEmptyErr: boolean = false;
  BaseVoucherListAddedSuccessfully: boolean = false;


  constructor(
    public activeModal: NgbActiveModal,
    public modal: NgbModal,
    public router: Router,
    private voucherInfoService: VoucherInformationService,
    private campaignService: CampaignService,
    private bundlePackageInfoService: BundlePackageInformationService,
    private transactionService: TransactionsService,
    private updateVoucherNoVariant: VoucherCodeService,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private voucherList: VoucherSearchUpdateService,
    private merchantService: MerchantService,
    private updateVoucherDetails: CreateVoucherService,
  ) {}

  ngOnInit() {
    this.campaignForm = this.fb.group({
      campaign: ['', Validators.required],
    });
    if (this.selectCampaign == true) {
      this.campaignService.getActiveCampaignList(0).subscribe((value) => {
        this.campaignService
          .getActiveCampaignList(value.data.pagination.count + 1)
          .subscribe((value) => {
            this.campaignList = value.data.campaigns;
          });
      });
    }

    if (this.cancelTransactionModal) {
      this.cancelTransactionForm = this.fb.group({
        remarks: ['', Validators.required],
      });
    }
  }

  voucherDetailPage() {
    this.router.navigate([`search-voucher`]);
    this.activeModal.close();
  }

  voucherDataPage() {
    this.router.navigate([`create-voucher`]);
    this.activeModal.close();
  }

  closeModal() {
    this.activeModal.close();
  }

  voucherActivePage(event: any) {
    if (event.target.innerText == 'Yes') {
      let active = event.target.innerText;
      let activeStatusData = {
        data: {
          voucher: {
            status: 'Active',
            active: true,
          },
        },
      };
      this.updateVoucherNoVariant
        .updateVoucherNoVariant(this.voucherId, activeStatusData)
        .subscribe((val: any) => {
          this.voucherInfoService.activeVoucherDetail(active);
          this.voucherDetailPage();
        });
    } else if (event.target.innerText == 'No') {
      let active = event.target.innerText;
      let deactiveStatusData = {
        data: {
          voucher: {
            status: 'Inactive',
            active: false,
          },
        },
      };
      this.updateVoucherNoVariant
        .updateVoucherNoVariant(this.voucherId, deactiveStatusData)
        .subscribe((val: any) => {
          this.voucherInfoService.activeVoucherDetail(active);
          this.voucherDetailPage();
        });
    }
  }

  variantActivePage(event: any) {
    if (event.target.innerText == 'Active') {
      let variantArr = [];
      for (let key of this.childStatusArr.keys()) {
        if (this.newVariantIdList.includes(this.childStatusArr.get(key).id)) {
          this.childStatusArr.set(key, {
            id: this.childStatusArr.get(key).id,
            active: true,
            status: 'ACTIVE',
            uiStatus: 'ACTIVE',
          });
        }
        if (this.childStatusArr.get(key).id != null) {
          variantArr.push({
            id: this.childStatusArr.get(key).id,
            active: this.childStatusArr.get(key).active,
            status: this.childStatusArr.get(key).status,
          });
        }
      }

      let activeStatusData = {
        data: {
          variants: variantArr,
        },
      };
      this.updateVoucherNoVariant
        .updateVoucherWithVariant(this.voucherId, activeStatusData)
        .subscribe((val: any) => {});
      this.voucherDetailPage();
    } else if (event.target.innerText == 'Deactive') {
      let variantArr = [];
      for (let key of this.childStatusArr.keys()) {
        if (this.newVariantIdList.includes(this.childStatusArr.get(key).id)) {
          this.childStatusArr.set(key, {
            id: this.childStatusArr.get(key).id,
            active: false,
            status: 'INACTIVE',
            uiStatus: 'INACTIVE',
          });
        }
        if (this.childStatusArr.get(key).id != null) {
          variantArr.push({
            id: this.childStatusArr.get(key).id,
            active: this.childStatusArr.get(key).active,
            status: this.childStatusArr.get(key).status,
          });
        }
      }
      let activeStatusData = {
        data: {
          variants: variantArr,
        },
      };
      this.updateVoucherNoVariant
        .updateVoucherWithVariant(this.voucherId, activeStatusData)
        .subscribe((val: any) => {});
      this.voucherDetailPage();
    }
  }

  withVariant(event: any) {
    if (event.target.innerText == 'Yes') {
      let variantOn = event.target.innerText;
      this.voucherInfoService.updateFormData(variantOn);
      this.voucherDataPage();
    }
  }

  withoutVariant(event: any) {
    this.voucherDataPage();
  }

  partialDeactivate(event: any) {
    if (event.target.innerText == 'Partial Activate') {
      this.voucherInfoService.updateVoucherStatusForPartial(
        'Partial Deactivate',
      );
      this.activeModal.close();
    }
  }

  totalDeactivate(event: any) {
    if (
      event.target.innerText == 'Total Deactivate' ||
      event.target.innerText == 'Deactive'
    ) {
      this.voucherInfoService.updateVoucherStatusForTotal(
        event.target.innerText,
      );
      this.activeModal.close();
    }
  }

  reactivate(event: any) {
    if (
      event.target.innerText == 'Re-Active' ||
      event.target.innerText == 'Active'
    ) {
      this.voucherInfoService.updateVoucherStatusForActive(
        event.target.innerText,
      );
      this.activeModal.close();
    }
  }

  bundleDetailPage() {
    this.router.navigate([`search-sales-combination`]);
    this.activeModal.close();
  }

  bundleActivePage(event: any) {
    if (event.target.innerText == 'Yes') {
      let active = event.target.innerText;
      this.bundlePackageInfoService.activeBundleDetail(active);
      this.bundleDetailPage();
    }
  }
  campaignActivated() {
    this.campaignService.getCampaignList(1, '', '', '').subscribe((value) => {
      if (value?.data?.campaigns) var lastID = value?.data?.campaignId;
      const requestnew = {
        data: {
          campaign: {
            active: true,
            status: 'ACTIVE',
          },
        },
      };
      this.campaignService
        .updateCampaign(requestnew, this.campaignId)
        .subscribe((value) => {
          if (value) {
            setTimeout(() => {
              this.router.navigate([`search-campaign`]);
            }, 1000);
          }
        });
      this.activeModal.close();
    });
  }

  campaignDrafted() {
    this.router.navigate([`search-campaign`]);
    this.activeModal.close();
  }

  passDate(evt: any) {
    this.formatDate = evt?.target?.value;
  }

  saveExpiryDate() {
    let id = this.transactionId;
    const utcTime = parseISO(this.formatDate);
    // toISOString() automatically converts it to UTC format
    const utcResult = utcTime.toISOString();
    let data = {
      enrichId: this.transactionDetail?.enrichId,
      expiryDate: utcResult, //Task 45090 convert local time to UTC
      remarks: this.remarks,
    };

    this.expiryDateExtendModal = false;
    this.transactionConfirmation('Do you want to extend the expiry date?');
    let confirmation =
      this.transactionService?.transactionConfirmationResponse?.subscribe(
        (value: any) => {
          if (value === 'Yes') {
            this.transactionService
              ?.updateExpiryDate(this.transactionDetail?.registryId, data)
              ?.subscribe((res: any) => {
                this.activeModal.close();
                this.transactionService
                  ?.getTransactionDetail(id)
                  ?.subscribe((res: any) => {
                    window.location.reload();
                  });
              });
            confirmation.unsubscribe();
          }
        },
      );
  }

  cancelTransaction() {
    this.remarks = this.cancelTransactionForm?.get('remarks')?.value?.trim();
    if (this.remarks) {
      let id = this.transactionId;
      let data = {
        remarks: this.remarks,
      };

      this.cancelTransactionModal = false;
      this.transactionConfirmation('Do you want to cancel this transaction?');
      let confirmation =
        this.transactionService?.transactionConfirmationResponse?.subscribe(
          (value: any) => {
            if (value === 'Yes') {
              this.transactionService
                ?.cancelTransaction(this.transactionDetail?.registryId, data)
                ?.subscribe((res: any) => {
                  this.activeModal.close();
                  this.transactionService
                    ?.getTransactionDetail(id)
                    ?.subscribe((res: any) => {
                      this.transactionSuccessModal = true;
                      this.transactionSuccessMsg = 'Transaction cancelled!';
                      this.router.navigate([`/transactions`]);
                      const modalRef = this.modal.open(
                        CommonModalComponent,
                        this.ngbModalOptions,
                      );
                      modalRef.componentInstance.transactionSuccessModal = true;
                      modalRef.componentInstance.transactionSuccessMsg =
                        'Transaction cancelled!';
                    });
                });
              confirmation.unsubscribe();
            }
          },
        );
    }
  }

  transactionConfirmation(msg: string) {
    this.transactionConfirmationMsg = msg;
    this.transactionConfirmationModal = true;
  }

  cancelTransactionError() {
    return (
      this.cancelTransactionForm?.touched &&
      this.cancelTransactionForm?.get('remarks')?.value?.trim() === ''
    );
  }

  transactionConfirmationPopUp() {
    this.transactionService?.setTransactionConfirmation('Yes');
    this.activeModal.close();
  }

  cancel() {
    this.activeModal.close();
  }

  saveOwnerDetail() {
    let id = this.transactionId;
    let data = {
      enrichId: this.transactionDetail?.enrichId,
      newEnrichId: this.newEnrichId,
      remarks: this.remarks,
    };

    this.changeOwnerModal = false;
    this.transactionConfirmation('Do you want to change the owner?');
    let confirmation =
      this.transactionService?.transactionConfirmationResponse?.subscribe(
        (value: any) => {
          if (value === 'Yes') {
            this.transactionService
              ?.updateOwner(this.transactionDetail?.registryId, data)
              ?.subscribe((res: any) => {
                this.activeModal.close();
                this.transactionService
                  ?.getTransactionDetail(id)
                  ?.subscribe((res: any) => {
                    window.location.reload();
                  });
              });
            confirmation.unsubscribe();
          }
        },
      );
  }

  statusChanged() {
    let id = this.transactionId;
    this.activeModal.close();
    this.transactionService?.getTransactionDetail(id)?.subscribe((res: any) => {
      window.location.reload();
    });
  }

  noDelete() {
    this.activeModal.close();
  }

  delete(id: any) {
    this.transactionService.deleteTransaction(id)?.subscribe((res: any) => {
      window.location.reload();
    });
  }

  updateExpiryDate(event: any, index: any) {
    this.voucherInfoService.updateExpiryDateStatus(
      event.target.innerText,
      index,
    );
    this.activeModal.close();
  }

  deleteDeactiveVoucher() {
    if (this.variantId) {
      this.voucherInfoService
        .deleteVoucherVariant(this.voucherId, this.variantId)
        .subscribe(
          (val: any) => {
            this.deleteVoucherConfirmationModal = false;
            this.deleteVoucherModal = true;
            this.deleteResponse = 'Variant deleted successfully!';
            this.deleteError = false;
            this.voucherInfoService.deleteVoucherVariantStatus(true);
          },
          (error: any) => {
            this.activeModal.close();
          },
        );
    } else {
      this.voucherInfoService.deleteVoucher(this.voucherId).subscribe(
        (val: any) => {
          this.deleteVoucherConfirmationModal = false;
          this.deleteVoucherModal = true;
          this.deleteResponse = 'Voucher deleted successfully!';
          this.deleteError = false;
          this.router.navigate([`search-voucher`]);
        },
        (error: any) => {
          this.activeModal.close();
        },
      );
    }
  }

  submit() {
    this.campaignFormSubmitted = true;
    if (this.campaignForm.valid) {
      this.activeModal.close();
      let campaignId = this.campaignForm.value.campaign;
      this.campaignService
        .createCampaignVoucher(
          campaignId,
          this.voucherId,
          this.campaignVoucherData,
        )
        .subscribe((val: any) => {
          if (val.message == 'success') {
            let id = val?.data?.voucher?.id;
            this.updateVoucherDetails
              .getCreateVoucherDetails(id)
              .subscribe((value: any) => {
                let active = value?.data?.voucher?.active;
                let status = value?.data?.voucher?.status;
                this.router.navigate([
                  `create-voucher/${id}/${status}/${active}/${campaignId}`,
                ]);
              });
          }
        });
    }
  }

  deleteCampaign() {
    this.campaignService.setCampaignDeletion('Yes');
    this.activeModal.close();
  }

  updateCampaignStatus(event: any, statusType: string) {
    if(this.campaignVoucherBulkUpdate) {
       this.updateCampaignVoucherBulkStatus(event, statusType);
    } else {
      const pyaload = {
      data: {
        campaign: {},
      },
    };

    pyaload.data.campaign = {...this.getStatusAndActive(statusType)};

    this.campaignService
      .updateCampaign(pyaload, this.campaignId)
      .subscribe((response) => {
        if (response) {
          this.activeModal.close('yes');
        } else {
          this.activeModal.close('no');
        }
      });
    }
  }

  updateCampaignVoucherBulkStatus(event: any, statusType: string) {
     const pyaload = {
      data: {
        voucherIds: this.campaignVoucherIdLists,
        ...this.getStatusAndActive(statusType)
      },
    };

    this.campaignService
      .updateBulkCampaignVoucherStatus(this.campaignId, pyaload)
      .subscribe((response) => {
        if (response) {
          this.activeModal.close('yes');
        } else {
          this.activeModal.close('no');
        }
     });

  }

  getStatusAndActive(statusType : string) {
   switch (statusType) {
      case 'partial' : return {active: true, status: 'INACTIVE'};
      case 'inactive' : return {active: false,status: 'INACTIVE'};
      default: return {active: true, status: 'ACTIVE'};
      };
    }
}
